module.exports = __webpack_public_path__ + "static/media/minus.8e213dc8.svg";